import { render, staticRenderFns } from "./LogoInversedCircle.vue?vue&type=template&id=68f20dae&"
import script from "./LogoInversedCircle.vue?vue&type=script&lang=js&"
export * from "./LogoInversedCircle.vue?vue&type=script&lang=js&"
import style0 from "./LogoInversedCircle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports